import { render } from "./EditPartenairePage.vue?vue&type=template&id=2e334254&ts=true"
import script from "./EditPartenairePage.vue?vue&type=script&lang=ts"
export * from "./EditPartenairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__